// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__d0cMI"};